import { Api } from 'Common/utils';

export function trackProductQuickviewClick(code) {
    return Api.POST('/tracking/trackProductQuickviewClick', {
        code,
    });
}

/**
 * @param {string|string[]} codes
 */
export function fetchProductDetails(codes) {
    const codeArr = typeof codes === 'string' ? [codes] : codes;
    const params = new URLSearchParams();

    for (const code of codeArr) params.append('code', code);

    return Api.GET('/product', params);
}

export function fetchProductsByNode(nodeId) {
    return Api.GET(`/product/getProductsByNode/${nodeId}`);
}

export function fetchRelatedProducts(code) {
    return Api.GET(`/product/${code}/recommendedProducts`);
}

export function fetchSpareParts(code) {
    return Api.GET(`/product/${code}/spareParts`);
}
